import { classNames } from '@axo/shared/util/dom';
import styles from './VerticalMenu.module.css';
import { IconButton } from '../IconButton';
import SearchBar from './SearchBar';
import { TreeMenu } from './TreeMenu';
import { permissions } from '@axo/shared/data-access/types';
import { Restricted } from '@axo/shared/feature/restricted';
import { useVerticalMenuStore } from './verticalMenuStore';

export function VerticalMenu() {
  const {
    expanded,
    actions: { toggleExpanded, setCollapsed },
  } = useVerticalMenuStore();

  return (
    <div
      className={classNames(
        styles.container,
        !expanded ? styles.collapsed : styles.expanded,
      )}
    >
      <div className={styles.sidebar}>
        <div className={styles.sidebarContent}>
          <div className={styles.sidebarTop}>
            <IconButton
              classes={{
                root: classNames(styles.button, styles.openButton),
              }}
              onClick={() => toggleExpanded()}
              icon={!expanded ? 'chevron-right' : 'chevron-left'}
              iconPlacement="right"
            >
              {expanded && <span className={styles.closeText}>Close menu</span>}
            </IconButton>
            <Restricted
              isAllowedFor={[
                permissions.RoleName.Manager,
                permissions.RoleName.Sales,
                permissions.RoleName.SecuredSales,
                permissions.RoleName.Telemarketing,
                permissions.RoleName.TelemarketingLimited,
              ]}
            >
              <SearchBar collapsed={!expanded} setCollapsed={setCollapsed} />
              <TreeMenu collapsed={!expanded} setCollapsed={setCollapsed} />
            </Restricted>
          </div>
          <div
            className={classNames(
              styles.sidebarBottom,
              !expanded && styles.sidebarBottomCollapsed,
            )}
          ></div>
        </div>
      </div>
    </div>
  );
}
